/**
 * Created by lenovo on 2017/3/14.
 */
import React, {Component} from 'react'
import {Link} from 'react-router'
import {language, getUserId, resultTip} from 'UTIL/common'
export default class FormInput extends Component {
    constructor(props) {
        super(props);
    }

    change() {
        const this_id = "error_" + this.props.id;
        var id = this.props.id;
        var maxLength = this.props.maxLength;
        var chartable = this.props.chartable == undefined ? false : this.props.chartable;
        var idLength = $("#" + id).val().length;
        if (chartable) {
            var reg = /^[0-9a-zA-Z]+$/;
            if (!reg.test($("#" + id).val())) {
                $("#error_" + this.props.id).html('请输入数字、字母或数字字母组合！');
                $("#error_" + this.props.id).attr("name", "error");
                $("#error_" + this.props.id).parent().attr("class", "errmsgtop");
                $("#error_" + this.props.id).siblings().attr("class", "triangle-down");
                $("#" + this.props.id).focus();
                return;
            }
        }


        if (maxLength < idLength) {
            $("#error_" + this.props.id).html('长度不允许超过' + maxLength + '个字符！');
            $("#error_" + this.props.id).attr("name", "error");
            $("#error_" + this.props.id).parent().attr("class", "errmsgtop");
            $("#error_" + this.props.id).siblings().attr("class", "triangle-down");
            $("#" + this.props.id).focus();
            return;
        }

        if ($.trim($("#" + this.props.id).val()) != "") {
            $("#" + this_id).html('');
            $("#" + this_id).attr("name", "success");
            $("#" + this_id).parent().attr("class", "");
            $("#" + this_id).siblings().attr("class", "");
        } else {
            $("#error_" + this.props.id).html('信息未填写！');
            $("#error_" + this.props.id).attr("name", "error");
            $("#error_" + this.props.id).parent().attr("class", "errmsgtop");
            $("#error_" + this.props.id).siblings().attr("class", "triangle-down");
            $("#" + this.props.id).focus();
        }
    }

    onKeyUp(event) {
        // if (this.props.onKeyUp != undefined && this.props.onKeyUp != null) {
        //     if (this.props.onKeyUp == 1) {//限制文本框只能输入正数，负数，小数
        //         var value = event.target.value;
        //         value = value.replace(/[^\-?\d.]/g, '')
        //         $("#" + this.props.id).val(value)
        //     }
        // }
        var value = $.trim($("#"+this.props.id).val());
        if (this.props.onKeyUp != undefined && this.props.onKeyUp == 4) {//长度4 只能是大写字母或者数字
            if (value == '') {
                return false;
            }
            //小写转大写
            value = value.toUpperCase();
            //判断是否为英文或数字
            var reg = /^[0-9a-zA-Z]+$/;
            if (!reg.test(value)) {
               value = value.substr(0, value.length - 1);
            }
            value = value.replace(/[^\w\.\/]/ig, '');
            //判断是否超过长度
            if (value.length > 4) {
                value = value.substr(0, 4);
            }
            $("#"+this.props.id).val(value)
        }
        if(this.props.integer){
            this.accuracyCheck(this.props.id)
        }
    }
    accuracyCheck(id) {//只能输入正整数
        var value = $("#" + id).val();

        if (value.length == 1) {
            value = value.replace(/[^1-9]/g, '')
        }
        else {
            value = value.replace(/\D/g, '')
        }
        $("#" + id).val(value);
    }
    render() {
        return (
            <div className="row form-group">
                <label className="multi-label control-label col-xs-2">{language()[this.props.name]}</label>
                <div className="col-xs-3">
                    <input type="text" className="form-control" onChange={this.change.bind(this)} autocomplete="off"
                           placeholder={language()[this.props.name]} id={this.props.id}
                           onKeyUp={this.onKeyUp.bind(this)}/>
                </div>
                <span className="">
                      <span id={"error_" + this.props.id} name="success"></span>
                      <span className=""></span>
                </span>
                <p className="form-control-static text-danger">
                    <span style={{fontSize: "20px"}}>*</span>
                </p>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./modules/component/form/formInput.js